import { removeExtraSpaces } from "./stringUtils";

export const compareTwoStrings = (
  firstString: string,
  secondString: string,
): boolean =>
  removeExtraSpaces(firstString.toLowerCase()) ===
  removeExtraSpaces(secondString.toLowerCase());
